export const searchData = {
  'searchResults': [],
  "searchTerm": '',
  "secondParam": ``,
  "searchPage": 1,
  "isFetching": true,
  "hasMoreItems": true
}


const firstPath =
  `https://api.unsplash.com/search/photos?client_id=DKN_OjGoHzp8eHky0eVnYH9abr_ViSrcNcW3ShY5zzs`

const secondPath = `https://api.pexels.com/v1/search?`

const firstParams = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
  },
};

const secondParams = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'MZPiduDSuiPB15Amk3Jekw6zjvrE3Tew5xsn7fBZ9mpdg8qF2vlrfOAl'

  },
};


let result = {}

export const getAPI = async function () {
  try {

    const firstResponse = await fetch(`${firstPath}&query=${searchData.searchTerm}}&page=${searchData.searchPage}&per_page=25${searchData.secondParam}`, firstParams)    
    
    let firstAPIFetching = true;
    let firstData
    
    if (!firstResponse.ok) {
      firstAPIFetching = false;
      console.log('First API threw an error, will try the second API')   
    } else {
      firstData = await firstResponse.json()
      if (firstData.results.length === 0) {
        firstAPIFetching = false;
        console.log('First API threw an error, will try the second API')   
      }   
    }
    console.log(firstAPIFetching)
    if (!firstAPIFetching) {
      const secondResponse = await fetch(`${secondPath}query=${searchData.searchTerm}}&page=${searchData.searchPage}&per_page=25${searchData.secondParam}`, secondParams)
      if (!secondResponse.ok) {
        throw new Error(`An error occurred for the second API: ${secondResponse.status}`);
      }

      const secondData = await secondResponse.json()
      results = secondData.photos;
      results.forEach(el => {
        result.id = el.id;
        result.description = el.alt;
        result.link = el.url
        result.raw = el.src.original;
        result.full = el.src.large;
        result.regular = el.src.medium;
        result.small = el.src.medium;
        result.thumb = el.src.tiny;
        searchData.searchResults.push(result)
        result = {}
      })

    } else {
      results = firstData.results
      results.forEach(el => {
        result.id = el.id;
        result.description = el.description;
        result.link = el.links.html
        result.raw = el.urls.raw;
        result.full = el.urls.full;
        result.regular = el.urls.regular;
        result.small = el.urls.small;
        result.thumb = el.urls.thumb;
        searchData.searchResults.push(result)
        result = {}
      })
    }
    // console.log(searchData)

  } catch (err) {
    console.log(`there is an error : ${err}`)
  }
}
